import * as yup from "yup";

export const JOM_IMPORT_FORM_SCHEMA = yup.object().shape({
  jomNumber: yup
    .string()
    .required("JOM broj je obavezan podatak"),
  chassisNumber: yup.string(),
  registrationNumber: yup.string(),
  kilometers: yup
    .string()
    .required("Kilometraža je obavezan podatak"),
});
